<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    destroy-on-close
    append-to-body
    @close="$emit('close')"
    width="500px"
  >
    <div slot="title" class="flex-line-between">
      <span class="fw-700 text-grey800 font-16"
        >Cuộc gọi {{ data.callType == "callout" ? "đi" : "đến" }}</span
      >
      <span class="px-2 rounded-1 bg-gray"
        >{{ app.user.username }} - {{ app.user.swUsername }}</span
      >
    </div>
    <div class="px-3 py-3 d-flex align-items-center bg-base-milk">
      <div class="d-flex flex-column justify-content-between" style="min-width: 150px">
        <span class="fw-semibold font-16 mb-2">{{ data.call?.toNumber }}</span>
        <!-- <span class="px-2 py-1 rounded-1 bg-green100 text-green700"
          >Thời lượng: {{ data?.callingDuration?.text }}</span
        > -->
      </div>
      <div class="input-wrapper">
        <el-input
          class="custom-input"
          v-model="note"
          maxlength="256"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          placeholder="Thêm ghi chú"
          :clearable="true"
          style="word-break: break-word; overflow-wrap: break-word;"
        ></el-input>
        <div class="char-counter">{{ note.length }} / 256</div>
      </div>
    </div>
    <el-divider class="my-0" />
    <div class="d-flex justify-content-end px-3 py-2">
      <el-button type="primary" @click="onSubmit"> Xong </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HTTP } from "@/lib/http-common";

export default {
  props: ["data"],
  data() {
    return {
      note: "",
    };
  },
  methods: {
    onSubmit() {
      HTTP.post("/api/call/note-call", {
        note: this.note,
        callId: this.data.call.callId,
        callCenterCode: "STRINGEE",
        phone: this.data.call.toNumber,
        direction: this.data.callType === "callout" ? "outbound" : "inbound",
        processId: this.app.globalProcessId == 'all' ? null : this.app.globalProcessId
      });
      this.alert("success", "Đã lưu!");
      this.$emit("close");
    },
  },
};
</script>

<style>
.input-wrapper {
  position: relative;
  width: 100%;
}

.char-counter {
  position: absolute;
  bottom: 8px;
  right: 10px;
  font-size: 12px;
  color: gray;
  pointer-events: none;
}
</style>
